<h3 class="meta-subheader flat">
  {{ context.type === 'project' ? 'Private Data Enclave Project Permissions' : 'Private Data Enclave Dataset Permissions' }}

  @if (context.editable) {
    <span class="action-button">
      <button mat-button type="button" (click)="startAdd()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        Add
      </button>
    </span>
  }
</h3>

@if (!context.editable && context.type == 'dataset' && context.organizationalAccess()) {
  <div class="meta-subcontent flat">Dataset Customer access given to {{ context.orgName }} users</div>
}

<div>
  <table mat-table class="mat-mdc-table rde-table" [dataSource]="tableRoles">
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let row">
        @if (newRow() === row) {
          @if (useEmailDropdown) {
            <mat-form-field subscriptSizing="dynamic">
              <mat-select [(value)]="row.email" placeholder="Select email">
                @for (email of availableEmails; track email) {
                  <mat-option [value]="email">
                    {{ email }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          } @else {
            <mat-form-field subscriptSizing="dynamic">
              <input
                matInput
                placeholder="Enter email"
                [(ngModel)]="row.email"
                name="email"
                email
                #emailInput="ngModel"
              />
              @if (emailInput.invalid && emailInput.touched) {
                <mat-error>Please enter a valid email address.</mat-error>
              }
            </mat-form-field>
          }
        } @else {
          {{ row.email }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let row">
        @if (editingRow() === row.email || newRow() === row) {
          <div class="select-wrapper">
            <mat-select [(value)]="row.roleId">
              @for (r of rolesAvailable(); track r.value) {
                <mat-option [value]="r.value">
                  {{ r.label }}
                </mat-option>
              }
            </mat-select>
          </div>
        } @else {
          {{ row.roleLabel }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" class="actions-cell">
        @if (editingRow() !== row.email && newRow() !== row) {
          <button mat-button type="button" (click)="onEdit(row)">
            <mat-icon class="material-symbols-outlined">edit</mat-icon>
            Edit
          </button>
        } @else {
          <button mat-button type="button" (click)="onSave(row)">
            <mat-icon class="material-symbols-outlined">save</mat-icon>
            Save
          </button>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" class="actions-cell">
        @if (editingRow() !== row.email && newRow() !== row) {
          <button mat-button type="button" (click)="onDelete(row)">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            Delete
          </button>
        } @else {
          <button mat-button type="button" (click)="cancel(row)">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
            Cancel
          </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (context.type == 'dataset' && context.editable) {
    <div class="standard-margin-top">
      <mat-checkbox [checked]="context.syncFromPrimaryProject()" (change)="onChangeSync($event.checked)">
        <span class="checkbox-label-content">
          Sync project permissions to this dataset
          <a
            href="/help/private-data-enclave/edit-private-dataset-access/edit-private-dataset-permissions"
            target="_blank"
            matIconButton
            class="help-icon-link"
            aria-label="Help for sync project permissions to this dataset"
          >
            <mat-icon class="material-symbols-outlined">help</mat-icon>
          </a>
        </span>
      </mat-checkbox>
    </div>
    @if (context.canEnableOrganizationalAccess) {
      <div>
        <mat-checkbox [checked]="context.organizationalAccess()" (change)="onChangeOrgAccess($event.checked)">
          <span class="checkbox-label-content">
            Give "Dataset Customer" access to everyone at {{ context.orgName }}
            <a
              href="/help/private-data-enclave/edit-private-dataset-access/edit-private-dataset-permissions"
              target="_blank"
              matIconButton
              class="help-icon-link"
              aria-label="Help for organizational access"
            >
              <mat-icon class="material-symbols-outlined">help</mat-icon>
            </a>
          </span>
        </mat-checkbox>
      </div>
    }
  }
</div>
